<script lang="ts">
  import WhatsAppTemplatePreview from "./_modules/whats-app-template-preview"
  import type { TemplatePageProps } from "../../_shared/_logic/announcement-templates-types"
  import { pageConfig } from "./config"

  const { activeTab }: TemplatePageProps = $props()
  const purpose = $derived(
    pageConfig.tabs?.find((tab) => tab.id === activeTab)?.id.slice("whatsapp-".length) ?? null,
  )
</script>

{#if purpose}
  <WhatsAppTemplatePreview {purpose} />
{/if}
